import type {
  ColumnSort,
  SortingState,
} from "@circleco/compass/components/DataTable";

import { DEFAULT_ORDER } from "../constants";
import type { PostsOrder } from "./types";

export const sortStateToOrder = (sort?: ColumnSort): PostsOrder | undefined =>
  sort?.id ? { [sort.id]: sort.desc ? "desc" : "asc" } : undefined;

export const orderToSortState = (order?: PostsOrder): SortingState => {
  const [orderKey, direction] = Object.entries(order ?? DEFAULT_ORDER)[0] ?? [];
  if (!orderKey) return [];

  return [{ id: orderKey, desc: direction === "desc" }];
};

export const orderParam = (order?: PostsOrder): { order?: PostsOrder } =>
  order ? { order } : {};
